/* eslint-disable react/prefer-es6-class */
import React from 'react';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/apps/settings/panel-mixin';

export const HelpPanel = React.createClass({
  displayName: 'HelpPanel',

  mixins: [PanelMixin],

  statics: {
    getTabName() {
      return t('shortcut keys');
    },
  },

  render() {
    return (
      <div className="help-block">
        <div className="keyboard-explanation">
          <table>
            <tbody>
              <tr>
                <td>
                  <div className="keys">
                    <div className="key long-key">
                      <div className="top-left text">Enter</div>
                      <div className="bottom-right text">↲</div>
                    </div>
                  </div>
                  <div className="explanation">{t('app_keys.confirm')}</div>
                </td>
                <td>
                  <div className="keys">
                    <div className="key long-key">
                      <div className="top-left text">Space</div>
                    </div>
                  </div>
                  <div className="explanation">{t('app_keys.play audio')}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="keys">
                    <div className="key">
                      <div className="arrow">↑</div>
                    </div>
                    <div className="key">
                      <div className="arrow">↓</div>
                    </div>
                  </div>
                  <div className="explanation">{t('move row and open/close sentence panel')}</div>
                </td>
                <td>
                  <div className="keys">
                    <div className="key">
                      <div className="arrow">←</div>
                    </div>
                    <div className="key">
                      <div className="arrow">→</div>
                    </div>
                  </div>
                  <div className="explanation">{t('select choice')}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="keys">
                    <div className="key">
                      <div className="text">S</div>
                    </div>
                  </div>
                  <div className="explanation">{t('practice spelling')}</div>
                </td>
                <td>
                  <div className="keys">
                    <div className="key">
                      <div className="text">Esc</div>
                    </div>
                  </div>
                  <div className="explanation">{t('close spelling practice')}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="keys">
                    <div className="key">
                      <div className="text">Ctrl</div>
                    </div>
                    <div className="key">
                      <div className="text">&lt;</div>
                    </div>
                  </div>
                  <div className="explanation">{t('hint')}</div>
                </td>
                <td>
                  <div className="keys">
                    <div className="key">
                      <div className="text">1</div>
                    </div>
                    <div className="not-key tilde">
                     ...
                    </div>
                    <div className="key">
                      <div className="text">5</div>
                    </div>
                  </div>
                  <div className="explanation">{t('multiple choice hotkey')}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  },
});

export default HelpPanel;
